const sentry_key = 'aa4e1d93d0ff4f949bffc352e9119282';
const sentry_app = '1521752';
export const sentry_url = `https://${sentry_key}@sentry.io/${sentry_app}`;

export const RELEASE = '7.1.1';
